import React, {Component} from 'react'
import {Grid, withStyles} from '@material-ui/core'
import CardNumberInput from '../CardNumberInput'
import ExpirationMonthInput from '../ExpirationMonthInput'
import CVVInput from '../CVVInput'
import CardHolderNameInput from '../CardHolderNameInput'
import style from './style'
import {PaymentFormActions} from "../../../../shared/actions"
import {connect} from 'react-redux'
import {bindActionCreators} from "redux"

class PaymentForm extends Component {

    componentDidMount = () => {
        const currentUrl = window.location.href;
        localStorage.setItem('currentHost', currentUrl);
    }

    commonHandleChange = (newInfo) => {
        const cardInfo = {
            ...newInfo,
            paymentMethodId: this.getPaymentMethodFrom(newInfo)
        }
        this.handleChange(cardInfo)
    }

    handleExpirationDataChange = (newInfo) => {
        const getData = (info, name) => ({
            key: name,
            value: newInfo[name],
            paymentMethodId: this.getPaymentMethodFrom(newInfo)
        });
        this.handleChange(getData(newInfo, 'card_expiration_month'))
        this.handleChange(getData(newInfo, 'card_expiration_year'))
    }

    handleChange = (cardInfo) => {
        this.props.actions.cardDataUpdated(cardInfo)
    }

    getPaymentMethodFrom = (newInfo) => {
        return !!newInfo && newInfo.paymentMethodId !== undefined
            ? newInfo.paymentMethodId
            : this.props.cardData.payment_method_id
    }

    render() {
        const {
            classes,
            cardBin,
            paymentMethod,
            paymentMethodId,
            binRanges
        } = this.props

        return (
            <Grid container spacing={16} className={classes.formContainer}>
                <Grid item xs={12}>
                    <CardNumberInput
                        name="cardNumber"
                        cardBin={cardBin}
                        paymentMethod={paymentMethod}
                        paymentMethodId={paymentMethodId}
                        binRanges={binRanges}
                        tabIndex={1}
                        updateCardData={this.commonHandleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <ExpirationMonthInput tabIndex={2}
                                          name="expirationMonth"
                                          paymentMethodId={paymentMethodId}
                                          updateCardData={this.handleExpirationDataChange}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <CVVInput name="cvv"
                              paymentMethod={paymentMethod}
                              tabIndex={3}
                              paymentMethodId={paymentMethodId}
                              updateCardData={this.commonHandleChange}/>
                </Grid>
                <Grid item xs={12}>
                    <CardHolderNameInput name="cardHolder"
                                         tabIndex={4}
                                         updateCardData={this.commonHandleChange}/>
                </Grid>
            </Grid>
        )
    }

}

const mapStateToProps = state => ({
    cardData: state.formInputData.cardData,
    paymentMethodId: state.formInputData.cardData.payment_method_id
})

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators({...PaymentFormActions}, dispatch)}
}

const Styled = withStyles(style)(PaymentForm)
const DataBound = connect(mapStateToProps, mapDispatchToProps)(Styled)

export default withStyles(style)(DataBound)
